export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-focus-3-line',
      title: '高精度な測定',
      description: 'ドリル・エンドミル・フライスカッターなどを高精度に測定が可能',
      image: 'https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/0ef81d6fea1d74ba93b0f815813a94b8.jpeg'
    },
    {
      icon: 'ri-settings-3-line',
      title: '大幅な段取り短縮',
      description: '工具補正の入力間違えがなくなる！スムーズな補正値転送',
      image: 'https://public.readdy.ai/ai/img_res/bab992f1e5a80ee6cccf7056e0741866.jpg'
    },
    {
      icon: 'ri-computer-line',
      title: 'アプリケーション',
      description: '刃先の摩耗を実写画像で観察、更に工具の刃ブレ測定も可能',
      image: 'https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/76f50a28cc20be9a8e43e88bf7db0c87.jpeg'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            製品特徴
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ZOLLERの最新技術により、工場での測定作業を革新的に改善します
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url(${feature.image})` }}></div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4">
                    <i className={`${feature.icon} text-xl text-gray-900`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl shadow-lg p-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-4">
              ※実機はSmileになります。
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div className="flex justify-center lg:justify-start">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/230cd34572fc96f54019301946b21444.jpeg"
                alt="ZOLLER Smile ツールプリセッター"
                className="rounded-lg shadow-md max-w-full h-auto"
              />
            </div>
            
            <div className="space-y-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">関連情報・サービス</h3>
              
              <div className="space-y-4">
                <a 
                  href="https://zoller-presetter.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block p-4 bg-gray-50 rounded-lg hover:bg-yellow-50 transition-colors cursor-pointer group"
                >
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-information-line text-gray-900"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 group-hover:text-yellow-600">
                        ZOLLERツールプリセッターの必要性のご案内
                      </h4>
                      <p className="text-sm text-gray-600">製品導入の効果と必要性について詳しくご紹介</p>
                    </div>
                    <i className="ri-external-link-line text-gray-400 ml-auto"></i>
                  </div>
                </a>

                <a 
                  href="https://zoller-boringchallenge.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block p-4 bg-gray-50 rounded-lg hover:bg-yellow-50 transition-colors cursor-pointer group"
                >
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-gift-line text-gray-900"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 group-hover:text-yellow-600">
                        ボーリングバーをご使用中のお客様へのキャンペーン企画
                      </h4>
                      <p className="text-sm text-gray-600">特別なキャンペーン情報をご確認いただけます</p>
                    </div>
                    <i className="ri-external-link-line text-gray-400 ml-auto"></i>
                  </div>
                </a>

                <a 
                  href="https://zollermicbox.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block p-4 bg-gray-50 rounded-lg hover:bg-yellow-50 transition-colors cursor-pointer group"
                >
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-cpu-line text-gray-900"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 group-hover:text-yellow-600">
                        業界初のスローアウェイチップ自動交換システム
                      </h4>
                      <p className="text-sm text-gray-600">革新的な自動交換システムの詳細情報</p>
                    </div>
                    <i className="ri-external-link-line text-gray-400 ml-auto"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
